import React, { useEffect, useMemo } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import JwtValidator from '../../utils/JwtValidator';
import { useAuth } from '@thingslog/utils';

const PrivateOutlet: React.FC<PrivateOutletProps> = ({ isInternal }: PrivateOutletProps) => {
  const navigate = useNavigate();
  const { isAuthenticated, isInitialized, login } = useAuth();
  // #region State
  const jwtValidator = useMemo(() => new JwtValidator(), []);
  // #endregion

  // #region Callbacks & Effects
  useEffect(() => {
    // Forces people with RESTRICTED role to only access /home
    if (isInternal && jwtValidator.hasRole('ROLE_RESTRICTED')) {
      navigate('/home2');
    }
  }, [jwtValidator, isInternal, navigate]);

  if (!isInitialized) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return (
      <div>
        Not Authenticated <button onClick={login}>Login</button>
      </div>
    );
  }

  return <Outlet />;
};

interface PrivateOutletProps {
  isInternal: boolean;
}

export default PrivateOutlet;
